<template>
    <header class="sticky top-0 z-30 flex border-b border-slate-200 bg-white">
        <div class="global-search-header-frame relative -mb-px flex h-16 w-full items-center">
            <!-- Header: Left side -->
            <div
                :class="[
                    'absolute inset-y-0 z-10 flex items-center transition-all duration-300 animate-in',
                    sidebarOpen ? 'left-64 px-4' : 'left-4',
                    'md:left-4 md:px-0', // override spacing on desktop
                ]"
            >
                <!-- Hamburger button -->
                <button
                    class="flex h-9 w-9 items-center justify-center text-slate-500 hover:text-slate-600"
                    aria-controls="sidebar"
                    :aria-expanded="sidebarOpen"
                    @click.stop="$emit('toggle-sidebar')"
                >
                    <span class="sr-only">Open sidebar</span>
                    <svg class="h-6 w-6 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <rect x="4" y="5" width="16" height="2" />
                        <rect x="4" y="11" width="16" height="2" />
                        <rect x="4" y="17" width="16" height="2" />
                    </svg>
                </button>
            </div>

            <div class="mx-auto flex min-w-0 w-full max-w-9xl justify-between px-3 md:px-4 lg:px-8">
                <div class="global-search-header-search min-w-0">
                    <GlobalSearchBar v-if="checkPermission('feature.global.creator_search')" />
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import { mapGetters } from 'vuex'
import GlobalSearchBar from '../components/GlobalSearchBar.vue'

export default {
    name: 'AppHeader',
    components: {
        GlobalSearchBar,
    },
    props: ['sidebarOpen'],
    data() {
        return {
            state: {
                modals: {
                    addCreator: {
                        isOpen: false,
                    },
                },
            },
        }
    },
    computed: {
        ...mapGetters(['selfActiveOrganization', 'isSfStaff', 'checkPermission']),
    },

    methods: {
        openCreateCampaignModal() {
            this.$store.commit('modal:open', 'create_campaign')
        },
    },
}
</script>

<style scoped>
.global-search-header-frame {
    container-type: inline-size;
}

.global-search-header-search {
    /* Keep this in sync with max-w-9xl in tailwind.config.js. */
    --header-content-max-width: 96rem;
    --header-container-padding: 0.75rem;
    --header-hamburger-safe-left: 4.25rem;

    padding-left: max(
        0rem,
        calc(
            var(--header-hamburger-safe-left) -
                (
                    max(calc((100cqw - var(--header-content-max-width)) / 2), 0rem) +
                        var(--header-container-padding)
                )
        )
    );
}

@media (min-width: 768px) {
    .global-search-header-search {
        --header-container-padding: 1rem;
    }
}

@media (min-width: 1024px) {
    .global-search-header-search {
        --header-container-padding: 2rem;
    }
}
</style>
